import React from 'react';
import Typography from '@material-ui/core/Typography';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Section, DataTable } from './shared';
import { useInsightsStyles } from '../styles';

const legacyColumns = [
  { key: 'screen_label', label: 'Old screen label', render: row => <strong>{row.screen_label}</strong> },
  { key: 'api', label: 'Old API', render: row => <code style={{ fontSize: '.72rem' }}>{row.api}</code> },
  { key: 'actually_counts', label: 'What it actually counts' },
  { key: 'replacement', label: 'Replaced by' },
];

/** `glossary[]` and `legacy_fields[]`, collapsed by default. */
const HowWeCount = ({ glossary = [], legacyFields = [] }) => {
  const classes = useInsightsStyles();
  return (
    <Section id="glossary" title="How we count" exportKey="glossary">
      <Accordion elevation={0} className={`${classes.panel} ${classes.sectionPanel}`} style={{ padding: 0 }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="glossary-content" id="glossary-header">
          <Typography style={{ fontWeight: 700, fontSize: '.9rem' }}>Definitions and what the old dashboard tiles meant</Typography>
        </AccordionSummary>
        <AccordionDetails id="glossary-content" style={{ display: 'block' }}>
          <dl style={{ margin: 0, display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
            {glossary.map(item => (
              <div key={item.key} style={{ minWidth: 0 }}>
                <dt><Typography style={{ fontWeight: 700, fontSize: '.84rem' }}>{item.label}</Typography></dt>
                <dd style={{ margin: 0 }}><Typography className={classes.description} style={{ marginTop: 2 }}>{item.definition}</Typography></dd>
              </div>
            ))}
          </dl>
          {legacyFields.length ? <>
            <Typography component="h3" className={classes.subheading}>Old dashboard tiles</Typography>
            <DataTable ariaLabel="What the old dashboard tiles counted" columns={legacyColumns} rows={legacyFields} getRowKey={(row, index) => `${row.screen_label}-${index}`} />
          </> : null}
        </AccordionDetails>
      </Accordion>
    </Section>
  );
};

export default HowWeCount;
